import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ConfigProvider, message } from 'antd';
import App from './App';
import './index.css';

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

// Toasts clear the screen quickly and never stack up over the header, so the
// cart and top nav stay usable right after adding an item (issue #124).
message.config({
  duration: 2,
  maxCount: 3,
});

// Ant Design theme configuration - DasoonEgg Brand Colors
const theme = {
  token: {
    // Brand primary color - golden/egg yellow
    colorPrimary: '#ffae00',
    colorPrimaryHover: '#cc9400',
    colorPrimaryActive: '#b38300',

    // Border radius
    borderRadius: 8,

    // Typography
    fontFamily: "'Jost', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",

    // Link colors using brand
    colorLink: '#ffae00',
    colorLinkHover: '#cc9400',
    colorLinkActive: '#b38300',

    // Success/Error colors matching dasoon-theme.css
    colorSuccess: '#4d8b55',
    colorError: '#D12323',

    // Background colors
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f0f2f5',
  },
  components: {
    // Menu component customization for dark theme
    Menu: {
      darkItemBg: '#2B302B',
      darkSubMenuItemBg: '#121512',
      darkItemSelectedBg: 'rgba(255, 174, 0, 0.15)',
      darkItemHoverBg: 'rgba(255, 174, 0, 0.08)',
      darkItemSelectedColor: '#ffae00',
      darkItemColor: 'rgba(255, 255, 255, 0.85)',
      darkItemHoverColor: '#ffae00',
    },
    Button: {
      primaryColor: '#ffffff',
    },
  },
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <QueryClientProvider client={queryClient}>
      <ConfigProvider theme={theme}>
        <App />
      </ConfigProvider>
    </QueryClientProvider>
  </BrowserRouter>
);